import { Component, HostListener, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { trigger, state, style, animate, transition } from '@angular/animations';


const style1 = style({
  opacity: 1
})

const style2 = style({
  opacity: 0
})


@Component({
  selector: 'fade-in',
  templateUrl: './fade-in.component.html',
  animations: [
    trigger('foobar', [
      state('show', style1),
      state('hide', style2),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
  ]
})
export class FadeInComponent implements OnChanges {
  @Input() public scrollEvent;
  state = 'hide'

  constructor(public el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.scrollEvent) {
      const componentPosition = this.el.nativeElement.offsetTop
      const scrollPosition = window.pageYOffset
      if (scrollPosition >= componentPosition - 250) {
        this.state = 'show'
      } else {
        this.state = 'hide'
      }
    }
  }
}